import { render, staticRenderFns } from "./RecuperaPassword.vue?vue&type=template&id=fdc6123a&"
import script from "./RecuperaPassword.vue?vue&type=script&lang=js&"
export * from "./RecuperaPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports